import useInfrastructure from '../../useInfrastructure';

const useTrackEvent = () => {
  const {
    analytics: { trackEvent },
  } = useInfrastructure();

  return trackEvent;
};

export default useTrackEvent;
